export enum PROFILE_TAB_URLS {
    MAIN = 'main',
    MATERIALS = 'materials',
    BLOG = 'blog',
    ACTIVITY = 'activity',
    FOLLOWING = 'following'
}
